import { FC, useCallback, useEffect, useState } from 'react';

import { useMst } from '../../store';
import { observer } from 'mobx-react-lite';

import cn from 'classnames';

import { Burger } from './components';

import { ConnectButton } from '..';

import logoIcon from 'assets/img/icons/logo.png';
import menuIcon from 'assets/img/icons/menu.svg';

import s from './Header.module.scss';

const Header: FC = observer(() => {
  const [isHeaderScrolled, setHeaderScrolled] = useState(false);
  const [isSearchVisible] = useState(false);
  const { sidebar } = useMst();

  const handleScroll = useCallback(() => {
    if (window.pageYOffset > 50) {
      setHeaderScrolled(true);
    } else {
      setHeaderScrolled(false);
    }
  }, []);

  useEffect(() => {
    handleScroll();
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return (
    <header
      className={cn(s.header_wrapper, {
        [s.header_wrapper_active]: isHeaderScrolled,
      })}
    >
      <div className={s.container}>
        <div className={s.burger_wrapper}>
          <Burger
            className={s.burger}
            onClick={sidebar.toggleSidebar}
            isMenuOpen={sidebar.isOpen}
          />
        </div>
        <div
          className={cn(s.logo_wrapper, {
            [s.logo_wrapper_hidden]: isSearchVisible,
          })}
        >
          <div
            className={s.menu_button}
            role="button"
            tabIndex={0}
            onKeyDown={() => {}}
            onClick={sidebar.toggleSidebar}
          >
            <img src={menuIcon} alt="menu" />
          </div>
          <a href="https://app.richquack.com/" className={s.logo}>
            <img src={logoIcon} alt="logo" width="24" height="24" />
            <div className={s.logo_text}>Rich Quack</div>
          </a>
        </div>
        {/* <div className={s.search}>
          <Search
            onChange={handleUpdateSearch}
            type="header"
            placeholder="Search for projects, donations or categories"
            handleChangeVisible={handleChangeIsSearchVisible}
            onKeyPress={handleSearch}
          />
        </div> */}
        <ConnectButton showOnMobile={false} />
      </div>
    </header>
  );
});

export default Header;
